module.exports = __webpack_public_path__ + "img/card-dark.dae58f50.svg";